import React, {Fragment} from 'react'

import {
  EuiBreadcrumbs,
  EuiSpacer
} from '@elastic/eui'


export default function ManualBreadcrumbs() {

  const breadcrumbs = [
    {
      text: 'Übersicht',
      href: '/de/Innenkameras/IN-3011/',
    },
    {
      text: 'Spezifikationen',
      href: '/de/Innenkameras/IN-3011/Technische_Spezifikationen/',
    },
    {
      text: 'Handbuch',
      href: '/de/Innenkameras/IN-3011/Handbuch/',
    },
    {
      text: '◄ Innenkameras',
      href: '/de/Innenkameras/',
    }
  ];

  return (
    <Fragment>
      <EuiBreadcrumbs
        truncate={true}
        breadcrumbs={breadcrumbs}
        aria-label="INSTAR IN-3011 Online Usermanual Chapters"
      />
      <EuiSpacer />
    </Fragment>
  );
}




// export default () => {
//   const breadcrumbs = [
//     {
//       text: 'Overview',
//       href: '/Indoor_Cameras/IN-3011/',
//     },
//     {
//       text: 'Technical Specifications',
//       href: '/Indoor_Cameras/IN-3011/Technical_Specifications/',
//     },
//     {
//       text: '◄ Usermanual',
//       href: '/Indoor_Cameras/IN-3011/Usermanual/',
//     }
//   ];

//   return (
//     <Fragment>
//       <EuiBreadcrumbs
//         truncate={true}
//         breadcrumbs={breadcrumbs}
//         aria-label="INSTAR IN-3011 Online Usermanual Chapters"
//       />
//       <EuiSpacer />
//     </Fragment>
//   );
// };